import { useEffect } from 'react';
import urlTemplate from 'url-template';
import type {
  AssignedUsersParams,
  AssignedUsersResponse,
} from 'src/apis/assignment-service/types';

import { useAxios } from 'src/hooks/use-axios';

type Props = {
  url: string;
  params: AssignedUsersParams;
};

export function useAssignedUsers({ url, params }: Props) {
  const assignedUsers = useAxios(
    (axios, baseConfig, { url, params }: Props) =>
      axios.request<AssignedUsersResponse>({
        ...baseConfig,
        url,
        params,
      }),
    { neededOnPageLoad: true }
  );

  useEffect(() => {
    const assignedUsersUrl = urlTemplate.parse(url).expand({});
    assignedUsers.execute({ url: assignedUsersUrl, params });
    // oxlint-disable-next-line exhaustive-deps
  }, [url, params]);

  return assignedUsers;
}

export type AssignedUsersRequest = ReturnType<typeof useAssignedUsers>;
